import React, { useMemo } from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import { PanelHeader } from 'js/components';

import JiraConfiguration from './configurations/JiraConfiguration';
import { CONNECTOR_SERVICES } from 'js/data/connectors';
import styles from './ConnectorSettings.module.scss';

const CONNECTOR_CONFIGURATIONS = {
  'jira-cloud': JiraConfiguration,
  // Future connector types will be added here
  // 'jira-server': JiraServerConfiguration,
  // slack: SlackConfiguration,
  // github: GitHubConfiguration,
};

function ConnectorEdit({
  onSubmit,
  onCancel,
  onTest,
  connector,
  workspace,
  issueFields,
  onQueryIssueFields,
}) {
  const ConfigurationComponent = CONNECTOR_CONFIGURATIONS[connector?.type];

  const serviceInfo = useMemo(
    () => CONNECTOR_SERVICES.find((service) => service.id === connector?.type),
    [connector?.type]
  );

  if (!workspace) {
    return (
      <Card>
        <CardBody>
          <div className="text-center py-4">
            <p className="text-muted">No workspace selected</p>
          </div>
        </CardBody>
      </Card>
    );
  }

  if (!connector) {
    return (
      <Card>
        <CardBody>
          <div className="text-center py-4">
            <p className="text-muted">Connector not found</p>
            <Button color="primary" onClick={onCancel}>
              Back to Connectors
            </Button>
          </div>
        </CardBody>
      </Card>
    );
  }

  return (
    <div>
      <PanelHeader size="sm" />
      <div className="content">
        <Card>
          <CardBody>
            {serviceInfo && (
              <div className={styles['service-card-configuring-container']}>
                <div className={styles['service-card']}>
                  <span className={styles['service-card-icon']}>
                    <img src={serviceInfo.logo} alt={serviceInfo.name} />
                  </span>
                  <span className={styles['service-card-title']}>
                    Configuring {serviceInfo.name}
                  </span>
                  <span className={styles['service-card-description']}>
                    {serviceInfo.description}
                  </span>
                </div>
              </div>
            )}

            {ConfigurationComponent && (
              <ConfigurationComponent
                connector={connector}
                onSubmit={onSubmit}
                onCancel={onCancel}
                onTest={onTest}
                isEdit={true}
                onBack={null}
                workspaceId={workspace?.id}
                connectorId={connector?.id}
                issueFields={issueFields}
                onQueryIssueFields={onQueryIssueFields}
              />
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default ConnectorEdit;
